
const AccessibilityTypeId = Object.freeze({
  NO_SUBTITLES: 1,
  SIGN_LANGUAGE_ASSISTED: 2,
  USING_AUDIO_DESCRIPTION: 3,
  USING_SUBTITLES: 4
})

export default AccessibilityTypeId
